module.exports = __webpack_public_path__ + "static/media/7.066b86b2.jpg";